var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import ExprInput from '../../designerComponents/ExprInput';
import WRadio from "../../components/Radio/index";
import { clone } from "lodash-es";
const modeDefaults = {
  auto: null,
  path: {
    type: 'path',
    path: ''
  },
  function: {
    type: 'function',
    code: '(item, index) => {\n  return item.xxxx\n}'
  }
};
const modeOptions = [{
  label: '自动',
  value: 'auto'
},
// { label: '从字段取', value: 'path' },
{
  label: '从表达式计算',
  value: 'function'
}];
let ListKeyingRuleInput = class ListKeyingRuleInput extends Vue {
  constructor() {
    super(...arguments);
    this.mode = 'auto';
  }
  created() {
    this.$watch(() => {
      var _this$editValue;
      return (_this$editValue = this.editValue) === null || _this$editValue === void 0 ? void 0 : _this$editValue.type;
    }, () => {
      var _this$editValue2;
      const val = (_this$editValue2 = this.editValue) === null || _this$editValue2 === void 0 ? void 0 : _this$editValue2.type;
      if (val === 'function') {
        this.mode = 'function';
        if (typeof this.editValue.code !== 'string') {
          this.editValue = {
            ...modeDefaults.function
          };
        }
      } else if (val === 'path') {
        this.mode = 'path';
        if (typeof this.editValue.path !== 'string') {
          this.editValue = {
            ...modeDefaults.path
          };
        }
      } else {
        this.mode = 'auto';
        if (this.editValue !== null) {
          this.editValue = null;
        }
      }
    }, {
      immediate: true
    });
  }
  changeMode(newMode) {
    this.editValue = clone(modeDefaults[newMode] || null);
  }
  render() {
    const h = arguments[0];
    let content;
    const ed = this.editValue;
    if ((ed === null || ed === void 0 ? void 0 : ed.type) === 'function') {
      content = h(ExprInput, {
        "attrs": {
          "value": ed.code,
          "type": "javascript",
          "notifyVoidReturn": true
        },
        "on": {
          "change": code => {
            this.editValue = {
              type: 'function',
              code
            };
          }
        }
      });
    } else if ((ed === null || ed === void 0 ? void 0 : ed.type) === 'path') {
      content = h("input", {
        "domProps": {
          "value": ed.path
        },
        "on": {
          "input": e => {
            const path = e.target.value;
            this.editValue = {
              type: 'path',
              path
            };
          }
        }
      });
    }
    return h("div", {
      "style": "flex-grow: 1; display: flex; flex-direction: column; gap: 4px;"
    }, [h("div", [h("w-radio", {
      "attrs": {
        "options": modeOptions,
        "value": this.mode
      },
      "on": {
        "change": this.changeMode
      }
    })]), this.mode !== 'auto' && h("div", [content])]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], ListKeyingRuleInput.prototype, "designer", void 0);
ListKeyingRuleInput = __decorate([Component({
  name: 'ListKeyingRuleInput',
  mixins: [vueComponentMixin],
  components: {
    WRadio
  }
})], ListKeyingRuleInput);
export default ListKeyingRuleInput;
//# sourceMappingURL=index.js.map
